var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocationBlue = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-location",
    x1: 0.061,
    y1: 0.15,
    x2: 0.939,
    y2: 0.718,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0173ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#0186ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#01b3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01c5ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34935",
    "data-name": "Group 34935",
    transform: "translate(-414 -592)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 35,
    height: 35,
    transform: "translate(414 592)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "location_grey",
    transform: "translate(403.428 582.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4987",
    transform: "translate(19699 22041.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8842",
    d: "M-19671-22031.9a11.043,11.043,0,0,0-10.928,11.154c-.064,10.645,10.928,23.846,10.928,23.846s10.992-13.2,10.928-23.846A11.087,11.087,0,0,0-19671-22031.9Z",
    fill: "url(#linear-gradient-location)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6606",
    "data-name": "Ellipse 6606",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(21.5 15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6607",
    "data-name": "Ellipse 6607",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(25.5 19)",
    fill: "#d7282f"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location-blue.8c9791e2.svg";
export { ForwardRef as ReactComponent };